export var needsCategories = {
  housing: {
    icon: 'HousingShelter',
    needs: ['Assisted Living', 'Emergency Housing', 'Environmental Exposure Assessment', 'Home Expense Assistance/Repairs', 'Home Loans and Financing', 'Homeless Drop-In Services', 'Housing Applications/Recertification', 'Housing Case Management', 'Housing Mediation & Eviction Prevention', 'Moving Assistance', 'Permanent Housing', 'Rent/Mortgage Payment Assistance', 'Transitional Housing']
  },
  food: {
    icon: 'Food',
    needs: ['Food Assistance', 'Emergency Food', 'Infant Formula/Food', 'Prepared Meals', 'Medically Tailored Meals', 'Produce Prescription/Voucher', 'School Meals', 'SNAP/WIC/Other Nutrition Benefits']
  },
  transportation: {
    icon: 'Transportation',
    needs: ['Ride Coordination', 'Non-Emergency Medical Transportation (NEMT)', 'Transportation Expense Assistance', 'Transportation Passes/Vouchers']
  },
  utilities: {
    icon: 'Utilities',
    needs: ['Home Energy/Utilities Benefits', 'Utility Bill Payment Assistance']
  },
  'Interpersonal-Safety': {
    icon: 'IndvFamSupport',
    needs: []
  }
};
var NEEDS = {
  housing: 'housing',
  food: 'food',
  transportation: 'transportation',
  utilities: 'utilities',
  interpersonalSafety: 'interpersonalSafety'
};
export default function getNeedIcon(need) {
  switch (need) {
    case NEEDS.housing:
      return 'HousingShelter';
    case NEEDS.food:
      return 'Food';
    case NEEDS.transportation:
      return 'Transportation';
    case NEEDS.utilities:
      return 'Utilities';
    case NEEDS.interpersonalSafety:
      return 'IndvFamSupport';
    default:
      return 'IconInfoCircle';
  }
}
//# sourceMappingURL=utils.js.map